<!-- Navigation Bar-->
<header id="topnav">
    <div class="topbar-main">
        <div class="container-fluid">
            <!-- Logo container-->
            <div class="logo">
                <!-- Image Logo -->
                <a href="index.html" class="logo">
                    <img src="./assets/global/images/logo_sm.png" alt="" height="26" class="logo-small">
                    <img src="./assets/global/images/logo_wtw.svg" alt="" height="40" class="logo-large">
                </a>
            </div>
            <!-- End Logo container-->
            <div class="menu-extras topbar-custom">
                <ul class="list-unstyled topbar-right-menu float-right mb-0">
                    <li class="menu-item">
                        <!-- Mobile menu toggle-->
                        <a class="navbar-toggle nav-link">
                            <div class="lines">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </a>
                        <!-- End mobile menu toggle-->
                    </li>
                    <li class="dropdown notification-list">
                        <a class="nav-link dropdown-toggle waves-effect nav-user" data-bs-toggle="dropdown" role="button" aria-haspopup="false" aria-expanded="false">
                            <img src="./assets/global/images/users/avatar-1.jpg" alt="user" class="rounded-circle"> <span class="ml-1 pro-user-name">{{userName}} <i class="mdi mdi-chevron-down"></i> </span>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right profile-dropdown ">
                            <!-- item-->
                            <!-- <button class="dropdown-item notify-item"><i class="fi-head"></i> <span>Mi Cuenta</span></button> -->
                            <!--item-->
                            <!-- <button class="dropdown-item notify-item"><i class="fi-cog"></i> <span>Configuración</span></button> -->
                            <!--item-->
                            <button class="dropdown-item notify-item" (click)="logOut()"><i class="fi-power"></i> <span>Cerrar Sesión</span></button>
                        </div>
                    </li>
                </ul>
            </div>
            <!-- end menu-extras -->
            <div class="clearfix"></div>
        </div>
        <!-- end container -->
    </div>
    <!-- end topbar-main -->
    <div class="navbar-custom">
        <div class="container-fluid">
            <div id="navigation">
                <!-- Navigation Menu-->
                <ul class="navigation-menu">
                    <li [routerLinkActive]='["link-active"]' class="has-submenu">
                        <a [routerLink]='[""]'>
                            <i class="icon-home"></i>{{"barraNavegacion.Inicio" | translate}}
                        </a>
                    </li>
                    <li class="has-submenu" [routerLinkActive]='["link-active"]'>
                        <a *ngIf="sarlaftMenu || reporteSarlaftMenu"><i class="icon-layers"></i>{{"barraNavegacion.Sarlaft" | translate}}</a>
                        <ul *ngIf="reporteSarlaftMenu || sarlaftMenu" class="submenu megamenu">
                            <li>
                                <ul>
                                    <li *ngIf="sarlaftMenu" [routerLinkActive]='["link-active"]'><a [routerLink]='["/sarlaft-form"]'>Actualización Sarlaft</a></li>
                                    <li *ngIf="reporteSarlaftMenu" [routerLinkActive]='["link-active"]'><a [routerLink]='["/sarlaft-form/reporte-sarlaft"]'>Reporte sarlaft</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li [routerLinkActive]='["link-active"]' class="has-submenu">
                        <a *ngIf="siniestrosMenu" [routerLink]='["/clains"]'><i class="icon-docs"></i>{{"barraNavegacion.Siniestros" | translate}}</a>
                        <ul *ngIf="radicacionMenu || incumpliminetoMenu || consultaYReportesMenu" class="submenu megamenu">
                            <li>
                                <ul>
                                    <li *ngIf="radicacionMenu" [routerLinkActive]='["link-active"]'><a [routerLink]='["/clains/radicacion-siniestro"]'>Radicación Siniestros</a></li>
                                    <li *ngIf="incumpliminetoMenu" [routerLinkActive]='["link-active"]'><a [routerLink]='["/clains/workflow-posible-incumplimiento"]'>Aviso Posible Incumplimiento</a></li>
                                    <li *ngIf="consultaYReportesMenu" [routerLinkActive]='["link-active"]'><a [routerLink]='["/clains/reportes-siniestro"]'>Reportes</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li class="has-submenu" [routerLinkActive]="['link-active']">
                        <a *ngIf="pacsMenu" [routerLink]='["/wepac"]'><i class="icon-people"></i>{{"barraNavegacion.PACs" | translate}}</a>
                        <ul *ngIf="creacionProgramaYContratistaMenu || solicitudDePolizaYModificacionesMenu || facturacionMenu" class="submenu">
                            <li> <a *ngIf="creacionProgramaYContratistaMenu" [routerLink]='["/wepac/program"]'>Creación de programas y contratistas</a></li>
                            <li><a *ngIf="solicitudDePolizaYModificacionesMenu" [routerLink]='["/wepac/solicitud-poliza"]'>Solicitud de Pólizas y modificaciones</a></li>
                            <li class="has-submenu">
                                <a *ngIf="gestionSolicitudes" [routerLink]='["/wepac/gestion-solicitudes"]'>{{"barraNavegacion.GestionSolicitud" | translate}}</a>
                                <ul class="submenu">
                                    <li [routerLinkActive]='["link-active"]'><a [routerLink]='["/wepac/gestion-solicitudes/workflow"]'>Workflow</a></li>
                                    <li [routerLinkActive]='["link-active"]'><a [routerLink]="['/wepac/gestion-solicitudes/autorizaciones']">Autorizaciones</a></li>
                                </ul>
                            </li>
                            <li> <a *ngIf="facturacionMenu" [routerLink]='["/wepac/billing/WP"]'>Facturación y Recaudo</a></li>
                            <li *ngIf="reportesConsultasReportesMenu" [routerLinkActive]='["link-active"]'><a [routerLink]='["/wepac/reportes-pacs"]'>Reportes</a></li>
                            <li *ngIf="polizasEmitidasPorFueraDelProgramaMenu" [routerLinkActive]='["link-active"]'><a [routerLink]='["/wepac/poliza-fuera-programa/workflowpfp"]'>Pólizas Emitidas Fuera de Programa</a></li>
                            <li *ngIf="controlCuposyCumulosMenu" [routerLinkActive]='["link-active"]'><a [routerLink]='["/cuposycumulos/workflowCuc"]'>Gestión de Cupos y Cúmulos</a></li>
                        </ul>
                    </li>
                    <li class="has-submenu" [routerLinkActive]="['link-active']">
                        <a *ngIf="weCumplimientoMenu" [routerLink]='["/weCumplimiento"]'><i class="icon-people"></i>{{"barraNavegacion.WeCumplimiento" | translate}}</a>
                        <ul *ngIf="weCumplimientoGenerarSolicitudMenu || weCumplimientoSolicitudesRecibidasMenu || weCumplimientoCuposCumulosMenu" class="submenu">
                            <li> <a *ngIf="weCumplimientoGenerarSolicitudMenu" [routerLink]='["/weCumplimiento/generarSolicitud"]'>Generar solicitud</a></li>
                            <li> <a *ngIf="weCumplimientoSolicitudesRecibidasMenu" [routerLink]='["/weCumplimiento/solicitudesRecibidas"]'>Solicitudes Recibidas</a></li>
                            <li> <a *ngIf="weCumplimientoReportesMenu" [routerLink]='["/weCumplimiento/Reportes"]'>Reportes</a></li>
                            <li> <a *ngIf="weCumplimientoCuposCumulosMenu" [routerLink]='["/weCumplimiento/CuposCumulos"]'>Gestión de cupos y cúmulos</a></li>
                            <li> <a *ngIf="weCumplimientoNegociacionAseguradoraMenu" [routerLink]='["/weCumplimiento/NegociacionAseguradoras"]'>Negociación Aseguradora</a></li>
                            <li> <a *ngIf="facturacionMenu" [routerLink]='["/wepac/billing/WC"]'>Facturación</a></li>
                        </ul>
                    </li>
                    <li class="has-submenu" [routerLinkActive]="['link-active']">
                        <a *ngIf="administracionMenu" administracionMenu [routerLink]="['/admin']"><i class="icon-briefcase"></i>{{"barraNavegacion.Administracion" | translate}}</a>
                        <ul *ngIf="usuariosMenu || auditoriaMenu || parametricasMenu" class="submenu megamenu">
                            <li>
                                <ul>
                                    <li [routerLinkActive]='["link-active"]'><a *ngIf="usuariosMenu" [routerLink]='["/admin/users"]'>{{"barraNavegacion.SubAdministracion.Usuarios" | translate}}</a></li>
                                    <li><a *ngIf="auditoriaMenu" href="#">Auditorías</a></li>
                                    <li [routerLinkActive]='["link-active"]'><a *ngIf="parametricasMenu" [routerLink]='["/admin/parameters"]'>Paramétricas</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li [routerLinkActive]='["link-active"]' class="has-submenu">
                        <a *ngIf="configuracionMenu" [routerLink]='["/admin/config"]'><i class="icon-settings"></i>{{"barraNavegacion.Configuracion" | translate}}</a>
                        <ul *ngIf="grupoEconomicoMenu || rolesMenu || empresasMenu || modulosMenu" class="submenu megamenu">
                            <li>
                                <ul>
                                    <li><a *ngIf="grupoEconomicoMenu" href="#">Grupo Económico</a></li>
                                    <li [routerLinkActive]='["link-active"]'><a *ngIf="rolesMenu" [routerLink]='["/admin/roles"]'>{{"barraNavegacion.SubConfiguracion.Roles" | translate}}</a></li>
                                    <li [routerLinkActive]='["link-active"]'><a *ngIf="empresasMenu" [routerLink]='["/admin/business"]'>{{"barraNavegacion.SubConfiguracion.Empresas" | translate}}</a></li>
                                    <li><a *ngIf="modulosMenu" href="#">Módulos</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li class="has-submenu" [routerLinkActive]='["link-active"]'>
                        <a *ngIf="administracionComercialMenu" [routerLink]='["/user-comercial"]' class="dropdown-item notify-item"><i class="icon-compass"></i> Administración comercial</a>
                    </li>
                    <li *ngIf="isTraduction" class="has-submenu">
                        <button class="dropdown-item notify-item" (click)="generalMethod.setLanguage('en')">{{"botones.Ingles" | translate}}</button>
                    </li>
                    <li *ngIf="isTraduction" class="has-submenu">
                        <button class="dropdown-item notify-item" (click)="generalMethod.setLanguage('es')">{{"botones.Español" | translate}}</button>
                    </li>
                </ul>
                <!-- End navigation menu -->
            </div>
            <!-- end #navigation -->
        </div>
        <!-- end container -->
    </div>
    <!-- end navbar-custom -->
</header>
<!-- End Navigation Bar-->